import React from "react";
import Cs from "../../../services/CommonService";
import {FormFieldCard} from "../../Common/FormFieldsView";
import {DraftBadge} from "../../Common/NotificationPill";
import useStyle from '../../../hooks/useStyle'

const ActivityCard = (props) => {
  useStyle('/css/tile_components.css', true)

  const {  formFields, activity, currentUser, toggleModal, enableScroll=true} = props;
  
  return (
    <div id="ct">
      <div className="bg-white brd-10 card-shadow m-b-15">
        <Header activity={activity} />
        <div className="card-content p20">
          <div className={"b-tab-table active "+(enableScroll?'scroll-auto ht-400':'')}>
            <div className="p-b-15 m-b-15 m-t-15">
              <FormFieldCard formFields={formFields} 
                dataSource={activity.data_source || {}}
                data={activity.data || {}}/>
            </div>
          </div>
        </div>
        <Footer {...{  activity, currentUser}}/>
      </div>
    </div>
  )
}

const Header = ({activity}) => (
  <div className="card-title card-title-gray flex p-b-15 p20 coldir">
    <h4 className="fw700 f18 card-heading flex coldir text-left">
      {/*Add Title*/}
    </h4>
    <div className="f14 m-t-10 fw500">
        <div>{activity.author_name}</div>
        <div>{Cs.formatUpdateDate(activity.updated_at)}</div>
        <DraftBadge isDraft={activity.draft}/>
    </div>
  </div>
)

const Footer = ({ activity, currentUser }) => {
  return(
    <div className="card-footer flex justspacebetween p20 aligncenter">
      <ul className="flex aligncenter">
        <li className="m-r-25">{activity.record_id}</li>
      </ul>
    </div>
  )
}

export default ActivityCard;